import { Navigate, Route, Routes, Link } from 'react-router-dom';
import Button from 'antd/es/button';
import theme from 'antd/es/theme';
import ConfigProvider, { ThemeConfig } from 'antd/es/config-provider';

import { c14142E, cBC44FF } from '#/colors';
import { INTERNAL_ALLOWLIST_ROUTE, INTERNAL_UTILS_ROUTE } from '#/routes';
import { MarketsSummaryStateProvider } from '#/features/perpetuals/market-info/markets-summary-context';

import QueryProvider from './QueryProvider';
import QuickDeposit from './QuickDeposit';
import QuickWithdrawal from './QuickWithdrawal';
import { Card, CardDescription, CardTitle, Container } from './atoms';
import { PRIME } from './utils';
import NumbersProcessing from './NumbersProcessing';
import OraclePrice from './OraclePrice';
import Allowlist from './Allowlist';
import OnChainAccountsTable from './accounts/OnChainAccountsTable';
import OnCloudAccountsTable from './accounts/OnCloudAccountsTable';
import TradeBustsTable from './tradebusts/TradeBustsTable';
import Contracts from './Contracts';

const THEME: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: cBC44FF,
    colorBgBase: c14142E,
    fontFamily: 'inherit',
  },
};

export default function InternalUtils() {
  return (
    <ConfigProvider theme={THEME}>
      <QueryProvider>
        <MarketsSummaryStateProvider>
          <Routes>
            <Route path="/" element={<InternalUtilsContent />} />
            <Route path="/allowlist" element={<Allowlist />} />
            <Route
              path="*"
              element={<Navigate to={INTERNAL_UTILS_ROUTE} replace />}
            />
          </Routes>
        </MarketsSummaryStateProvider>
      </QueryProvider>
    </ConfigProvider>
  );
}

function InternalUtilsContent() {
  return (
    <Container>
      <div css="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; width: auto; grid-gap: 20px;">
        <Card css="grid-column: 1/-1">
          <Link to={INTERNAL_ALLOWLIST_ROUTE}>
            <Button>Allowlist</Button>
          </Link>
        </Card>
        <Card css="grid-column: 1/-1">
          <CardTitle>All Accounts</CardTitle>
          <CardDescription>
            Information about the accounts in the system
          </CardDescription>

          <CardDescription>On-Cloud Accounts:</CardDescription>
          <OnCloudAccountsTable />

          <CardDescription>On-Chain Accounts:</CardDescription>
          <OnChainAccountsTable />
        </Card>

        <Card css="grid-column: 1/-1">
          <CardTitle>Trade Busts</CardTitle>
          <TradeBustsTable />
        </Card>

        <Card css="grid-column: 1/2">
          <CardTitle>L2 deposit</CardTitle>
          <CardDescription>
            Deposit USDC from your StarkNet account into Paradex.
          </CardDescription>
          <QuickDeposit />
        </Card>
        <Card css="grid-column: 2/3">
          <CardTitle>L2 withdraw</CardTitle>
          <CardDescription>
            Withdraw USDC from Paradex to StarkNet wallet
          </CardDescription>
          <QuickWithdrawal />
        </Card>
        <Card css="grid-column: 3/5">
          <CardTitle>Contracts</CardTitle>
          <Contracts />
        </Card>

        <Card css="grid-column: 1/3">
          <CardTitle>Numbers processing</CardTitle>
          <CardDescription>
            Returns the lift of the given field element, val, as an integer in
            the range (-PRIME/2, PRIME/2).
            <br />
            PRIME=&apos;{PRIME.toFixed()}&apos;
            <NumbersProcessing />
          </CardDescription>
        </Card>
        <Card css="grid-column: 3/5">
          <CardTitle>Oracle Price Management</CardTitle>
          <CardDescription>
            Allows to pause, resume, override live oracle data
          </CardDescription>
          <OraclePrice />
        </Card>
      </div>
    </Container>
  );
}
